import React, { createContext, useContext, useEffect, useState } from "react";
import classNames from "classnames";

const ThemeContext = createContext();
const ThemeUpdateContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function useThemeUpdate() {
  return useContext(ThemeUpdateContext);
}

const ThemeProvider = ({ ...props }) => {
  const [theme, setTheme] = useState({
    main: "default", //other value can be passed "clean,shady,softy"
    sidebar: props.mode === undefined ? "light" : props.mode, //other value can be passed "light,white,theme"
    sidebarCompact: false,
    sidebarVisibility: false,
    sidebarMobile: false,
    header: props.mode === undefined ? "light" : props.mode, //other value can be passed "light,dark,theme"
    skin: props.mode === undefined ? "light" : props.mode, //other value can be passed "dark"
  });

  const themeUpdate = {
    uistyle: function (value) {
      setTheme({ ...theme, main: value });
    },
    sidebar: function (value) {
      setTheme({ ...theme, sidebar: value });
    },
    sidebarCompact: function (e) {
      setTheme({ ...theme, sidebarCompact: !theme.sidebarCompact });
    },
    sidebarVisibility: function (e) {
      setTheme({ ...theme, sidebarVisibility: !theme.sidebarVisibility });
    },
    sidebarHide: function (e) {
      setTheme({ ...theme, sidebarVisibility: false });
    },
    header: function (value) {
      setTheme({ ...theme, header: value });
    },
    skin: function (value) {
      setTheme({ ...theme, skin: value });
    },
    reset: function (e) {
      setTheme({ ...theme, main: theme.main, sidebar: theme.sidebar, header: theme.header, skin: theme.skin });
    },
  };

  const bodyClass = classNames({
    "nk-body bg-lighter npc-default has-sidebar no-touch nk-nio-theme": true,
  });

  useEffect(() => {
    const body = document.querySelector("body");
    body.className = bodyClass;
  }, []);

  useEffect(() => {
    const body = document.querySelector("body");
    if (theme.main === "default") {
      body.classList.add("ui-default");
      body.classList.remove("ui-clean", "ui-shady", "ui-softy");
    }
    if (theme.main === "clean") {
      body.classList.add(`ui-clean`);
      body.classList.remove("ui-default", "ui-shady", "ui-softy");
    }
    if (theme.main === "shady") {
      body.classList.add(`ui-shady`);
      body.classList.remove("ui-default", "ui-clean", "ui-softy");
    }
    if (theme.main === "softy") {
      body.classList.add(`ui-softy`);
      body.classList.remove("ui-default", "ui-clean", "ui-shady");
    }
    if (props.mode === "dark") {
      body.classList.add(`dark-mode`);
    } else {
      body.classList.remove("dark-mode");
    }
    if (theme.sidebarVisibility === true) {
      body.classList.add("nav-shown");
    } else {
      body.classList.remove("nav-shown");
    }
  }, [theme, props.mode]);

  const body = document.querySelector("body");
  const observer = new ResizeObserver((entries) => {
    let width = entries[0].contentRect.width;
    if (width < 1200) {
      setTheme({ ...theme, sidebarMobile: true });
    } else {
      setTheme({ ...theme, sidebarMobile: false, sidebarVisibility: false });
    }
  });
  // observer.observe(body);

  return (
    <ThemeContext.Provider value={theme}>
      <ThemeUpdateContext.Provider value={themeUpdate}>{props.children}</ThemeUpdateContext.Provider>
    </ThemeContext.Provider>
  );
};
export default ThemeProvider;
